var _g, _path, _g2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBTopLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1305,
    height: 772,
    viewBox: "0 0 1305 772",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_diamond_738_5239_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.167943 -0.219892 0 761 235)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 583.532,
    height: 195.551,
    fill: "url(#paint0_diamond_738_5239)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 583.532,
    height: 195.551,
    transform: "scale(1 -1)",
    fill: "url(#paint0_diamond_738_5239)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 583.532,
    height: 195.551,
    transform: "scale(-1 1)",
    fill: "url(#paint0_diamond_738_5239)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 583.532,
    height: 195.551,
    transform: "scale(-1)",
    fill: "url(#paint0_diamond_738_5239)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M761 235L803 259.25V307.75L761 332L719 307.75V259.25L761 235Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.99215686321258545,\"g\":0.76862746477127075,\"b\":0.33333334326744080,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":1.0,\"g\":0.37034255266189575,\"b\":0.52372062206268311,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"stopsVar\":[{\"color\":{\"r\":0.99215686321258545,\"g\":0.76862746477127075,\"b\":0.33333334326744080,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":1.0,\"g\":0.37034255266189575,\"b\":0.52372062206268311,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"transform\":{\"m00\":-5.6034652829231590e-13,\"m01\":-439.78305053710938,\"m02\":980.89154052734375,\"m10\":335.88531494140625,\"m11\":-8.4057306742272436e-14,\"m12\":67.057334899902344},\"opacity\":0.89999997615814209,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_diamond_738_5239_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.16902 -0.221314 0 760.994 234.746)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 196.425,
    fill: "url(#paint1_diamond_738_5239)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 196.425,
    transform: "scale(1 -1)",
    fill: "url(#paint1_diamond_738_5239)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 196.425,
    transform: "scale(-1 1)",
    fill: "url(#paint1_diamond_738_5239)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 584.678,
    height: 196.425,
    transform: "scale(-1)",
    fill: "url(#paint1_diamond_738_5239)",
    opacity: 0.9,
    shapeRendering: "crispEdges"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M760.994 234.746L803.266 259.152V307.963L760.994 332.368L718.723 307.963V259.152L760.994 234.746Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":0.99215686321258545,\"g\":0.76862746477127075,\"b\":0.33333334326744080,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":1.0,\"g\":0.37034255266189575,\"b\":0.52372062206268311,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"stopsVar\":[{\"color\":{\"r\":0.99215686321258545,\"g\":0.76862746477127075,\"b\":0.33333334326744080,\"a\":1.0},\"position\":0.24433699250221252},{\"color\":{\"r\":1.0,\"g\":0.37034255266189575,\"b\":0.52372062206268311,\"a\":0.80000001192092896},\"position\":0.73151022195816040}],\"transform\":{\"m00\":-5.6397128720547807e-13,\"m01\":-442.62792968750,\"m02\":982.30828857421875,\"m10\":338.04010009765625,\"m11\":-8.4596555021548836e-14,\"m12\":65.726036071777344},\"opacity\":0.89999997615814209,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_diamond_738_5239_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M761 235L803 259.25V307.75L761 332L719 307.75V259.25L761 235Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_diamond_738_5239_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760.994 234.746L803.266 259.152V307.963L760.994 332.368L718.723 307.963V259.152L760.994 234.746Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_diamond_738_5239",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244337,
    stopColor: "#FDC455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73151,
    stopColor: "#FF5E86",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_diamond_738_5239",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244337,
    stopColor: "#FDC455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73151,
    stopColor: "#FF5E86",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBTopLight);
export default __webpack_public_path__ + "static/media/b_top_light.1ce1d6822985dfe7f5147d93a89cf31f.svg";
export { ForwardRef as ReactComponent };